import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  path: '',
  method: 'POST',
  authentication: 'none',
  responseMode: 'immediate',
  responseData: '{ "status": "received" }',
  testInput: '{}',
};

export default defaults;
